import * as types from '../constants/idpAdminActions';
import * as messageConstants from "../shared/messages";

const initialState = {
  errorMsg: null,
  successMsg: null,
  customizationSettings: null,
  saveCustomizationInProgress: false,
};

export default function orgs(state = initialState, action = {}) {
  switch (action.type) {
    case types.SAVE_CUSTOMIZATION_START:
      return {
        ...state,
        errorMsg: null,
        successMsg: null,
        saveCustomizationInProgress: true
      };
    case types.SAVE_CUSTOMIZATION_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        successMsg: messageConstants.CUSTOMIZATION_SAVED,
        customizationSettings: action.response.data,
        saveCustomizationInProgress: false,
      };
    case types.SAVE_CUSTOMIZATION_FAIL:
      return {
        ...state,
        errorMsg: action.errorMsg,
        successMsg: null,
        saveCustomizationInProgress: false,
      };
    case types.GET_CUSTOMIZATION_START:
      return {
        ...state,
        errorMsg: null,
        successMsg: null,
        getCustomizationInProgress: true
      };
    case types.GET_CUSTOMIZATION_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        successMsg: null,
        customizationSettings: action.response,
        getCustomizationInProgress: false,
      };
    case types.GET_CUSTOMIZATION_FAIL:
      return {
        ...state,
        errorMsg: action.errorMsg,
        successMsg: null,
        customizationSettings: null,
        getCustomizationInProgress: false,
      };
    case types.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMsg: action.errorMsg,
        successMsg: null
      }
    case types.CLEAR_MESSAGES:
      return {
        ...state,
        errorMsg: null,
        successMsg: null
      }
    default:
      return state;
  }
}
